import ExcelJS from "exceljs";
import axios from "axios";
import logo from "../assets/legalpanel-dark.png";
import innerText from "./innerText";

export async function exportTableToExcel({
  columns,
  dataSource,
  expandable,
  history,
  formatter,
}) {
  try {
    const logoBuffer = (
      await axios.get(logo, { baseURL: null, responseType: "arraybuffer" })
    ).data;

    let wbNome = [document.title];
    let wsNome;
    const pathname = history.location.pathname;
    const index = pathname.lastIndexOf("/");
    if (index >= 0) {
      wsNome = pathname.substring(index + 1);
      wbNome.push(wsNome);
    }
    wbNome.push(new Date().toLocaleString());
    wbNome = wbNome.join(" - ");

    const wb = new ExcelJS.Workbook();
    const logoImageId = wb.addImage({ buffer: logoBuffer, extension: "png" });

    const ws = wb.addWorksheet(wsNome);
    ws.addImage(logoImageId, {
      tl: { col: 0.25, row: 0.5 },
      editAs: "absolute",
      ext: { width: 120, height: 24 },
      hyperlinks: { hyperlink: location.origin, tooltip: location.origin },
    });

    const headerRow = ws.getRow(1);
    headerRow.height = 28;
    headerRow.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF262626" },
    };

    const cols = columns.map((column) => ({
      ...column,
      width: column.title?.length ?? 1,
      getCellValue(row) {
        let width = 8;
        let text;
        if (Array.isArray(column.dataIndex))
          text = column.dataIndex.reduce((pv, cv) => pv && pv[cv], row);
        else text = row[column.dataIndex];

        if (typeof column.render === "function")
          text = column.render(text, row);
        text = innerText(text);

        if (column.width) width += Math.ceil(column.width / 15);
        else if (text?.length) width += text.length;

        this.width = Math.max(this.width, width);
        return text;
      },
    }));

    const getCols = (row, depth) =>
      cols.map((column, i) => {
        let value = column.getCellValue(row);
        try {
          if (/^-?[\d.,]+$/.test(value)) {
            const number = formatter.parseNumber(value);
            if (isFinite(number)) return number;
          }
        } catch (e) {
          console.error(e);
        }
        if (depth > 0 && i === 0) value = " ".repeat(4 * depth) + value;
        return value;
      });

    const getRows = (rows, depth = 0) => {
      const result = [];
      for (const row of rows) {
        result.push(getCols(row, depth));
        const children = row[expandable?.childrenColumnName];
        if (children?.length > 0) result.push(...getRows(children, depth + 1));
      }
      return result;
    };

    ws.addTable({
      name: wsNome,
      ref: "A2",
      headerRow: true,
      style: { theme: "TableStyleLight1", showRowStripes: true },
      columns: cols.map((column) => ({
        name: column.title,
        filterButton: true,
      })),
      rows: getRows(dataSource),
    });

    for (let i = 0; i < ws.columns.length; i++)
      ws.columns[i].width = cols[i].width + 8;

    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const a = document.createElement("a");
    a.style.display = "none";
    a.setAttribute("href", window.URL.createObjectURL(blob));
    a.setAttribute("download", `${wbNome}.xlsx`);
    a.click();

    await new Promise((resolve) => setTimeout(resolve, 5000));
  } catch (e) {
    console.error(e);
    throw e;
  }
}
